import Stack from '@mui/material/Stack';
import ControlState from '../Shared/controlState';
import { PopoverKind } from './PopoverContent';
import ControlKind from '../Shared/controlKind';
import { useContext, useState } from 'react';
import { WorkflowEngineContext } from '../WorkflowEngine/workflowEngineReducer';
import ConditionalToggleBtn from './buildToolButtons/ConditionalToggleBtn';
import MoveToAnotherSectionBtn from './buildToolButtons/MoveToAnotherSectionBtn';
import DeleteBtn from './buildToolButtons/DeleteBtn';
import ReOrderPagesBtn from './buildToolButtons/ReorderPagesBtn';
import ReorderPagesDialog from './ReorderPagesDialog';
import * as _ from "lodash";
import DuplicateComponentButton from './buildToolButtons/DuplicateComponentButton';

export default (props: {
  isActive: boolean;
  control: ControlState;
  openPopover: (
    anchorEl: HTMLButtonElement | null,
    popoverKind: PopoverKind
  ) => void;
}) => {
  const { isActive, control, openPopover } = props;
    const { building, kind } = control;

  const { state } = useContext(WorkflowEngineContext);
  const { pages } = state;

    const [openDialog, setOpenDialog] = useState<boolean>(false);

  const isPage = kind === ControlKind.PAGE;

  const canDelete = !isPage || pages.length > 1;

  const renderConditionalBtn = () => {
    return !isPage && <ConditionalToggleBtn control={control} />;
  };

  const renderMoveToAnotherSectionBtn = () => {
    return (
      isActive &&
      building &&
      pages.length > 1 &&
      !isPage && <MoveToAnotherSectionBtn openPopover={openPopover} />
    );
  };

  const renderDeleteBtn = () => {
    return (
      isActive &&
      canDelete && (
        <DeleteBtn
          popoverKind={
            isPage ? PopoverKind.REMOVE_PAGE : PopoverKind.REMOVE_CONTROL
          }
          openPopover={openPopover}
        />
      )
    );
    };

  const renderCopyBtn = () => {
     return isActive&&
     !building && !isPage &&(
         <DuplicateComponentButton control={control} />
     )
  };

  const renderMoreBtn = () => {
    //TODO: Placeholder that will be enable on a later phase
    // return building && (
    //     <IconButton aria-label="More">
    //     <MoreVertIcon />
    //   </IconButton>
    // ))
    return <></>;
  };

  const renderReOrderPages = () => {
    return (
      isActive &&
      pages.length > 1 &&
      isPage && <ReOrderPagesBtn handleOpenDialog={handleOpenDialog} />
    );
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Stack direction="row" sx={{ marginRight: '5px' }}>
        {renderCopyBtn()}
        {renderMoveToAnotherSectionBtn()}
        {renderReOrderPages()}
        {renderDeleteBtn()}
        {renderConditionalBtn()}
        {renderMoreBtn()}
      </Stack>
      <ReorderPagesDialog
        openDialog={openDialog}
        closeDialog={handleCloseDialog}
      />
    </>
  );
};
